// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//cdn.jsdelivr.net/npm/@mdi/font@6.9.96/css/materialdesignicons.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
